export const zh = {
  translation: {
    pageTitle: 'OneKey 设备管理工具',
    pageSubtitle: '搜索设备',
    // 添加头部标题翻译
    header: {
      title: 'OneKey 开发者门户',
      version: '版本',
    },
    common: {
      device: '设备',
      chainMethods: 'Signer',
      deviceMethods: '设备方法',
      firmware: '固件更新',
      logs: '日志',
      connect: '连接',
      shareLog: '分享日志',
      features: '获取特性',
      search: '搜索设备',
      connection: '连接',
      response: '响应',
      getAddress: '获取地址',
      getPublicKey: '获取公钥',
      signMessage: '签名消息',
      signTransaction: '签名交易',
      noResponse: '没有可用的响应数据',
      copy: '复制',
      networks: '网络',
      home: '首页',
      emulator: '模拟器',
      navigation: '导航',
      current: '当前',
      toggleTheme: '切换主题',
      toggleSidebar: '切换侧边栏',
      docs: '文档',
      ready: '就绪',
      waiting: '等待',
      explore: '探索',
      back: '返回列表',
      dangerous: '危险',
      requiresConfirmation: '需要确认',
      loading: '加载中...',
      execute: '执行',
      confirm: '确认',
      deviceManagement: '设备管理',
      deviceManagementDesc: '设备状态查询、配置和管理操作',
      basicOperations: '基本操作',
      basicOperationsDesc: '基本设备连接和通信操作',
      cancel: '取消',
      error: '错误',
      goToHomePage: '前往主页',
      goHome: '返回主页',
      connecting: '连接中',
      connected: '已连接',
      disconnected: '未连接',
      deviceName: '设备名称',
      deviceType: '设备类型',
      uuid: 'UUID',
      connectId: '连接ID',
      transport: '传输方式',
      firmwareVersion: '固件版本',
      bluetoothVersion: '蓝牙版本',
      bootVersion: 'Boot版本',
      pinInputSupport: '客户端中输入PIN码',
      supported: '支持',
      notSupported: '不支持',
      deviceInfo: '设备信息',
      save: '保存',
      edit: '编辑',
      copied: '已复制',
      clear: '清除',
      reset: '重置',
      required: '必填',
      optional: '可选',
      success: '成功',
      failed: '失败',
      retry: '重试',
      close: '关闭',
      open: '打开',
      expand: '展开',
      collapse: '收起',
      show: '显示',
      hide: '隐藏',
      enabled: '已启用',
      disabled: '已禁用',
      yes: '是',
      no: '否',
      all: '全部',
      none: '无',
      select: '选择',
      upload: '上传',
      download: '下载',
      file: '文件',
      size: '大小',
      format: '格式',
      type: '类型',
      status: '状态',
      progress: '进度',
      completed: '已完成',
      pending: '待处理',
      processing: '处理中',
      cancelled: '已取消',
      timeout: '超时',
      unknown: '未知',
      seInfo: '设备 SE 信息',
    },
    deviceInfo: {
      deviceInfo: '设备信息',
      seInfo: '设备 SE 信息',
    },
    home: {
      title: 'OneKey 硬件钱包 SDK',
      subtitle: '探索并测试 OneKey 硬件钱包 SDK 功能',
      deviceMethods: '设备方法',
      deviceMethodsDesc: '访问设备信息、管理设置并执行设备特定操作',
      chainMethods: 'Signer',
      chainMethodsDesc: '通过您的 OneKey 设备与不同的区块链网络进行交互',
      logs: '系统日志',
      logsDesc: '查看所有设备操作和 API 交互的详细日志',
      quickStart: '快速入门指南',
      quickStartDesc: '按照这些简单的步骤开始使用 OneKey SDK',
      step1: '通过 USB 或蓝牙连接您的 OneKey 设备',
      step2: '选择传输方法（WebUSB 或 JSBridge）',
      step3: '探索设备方法以管理您的硬件钱包',
      step4: '测试链方法以与区块链进行交互',
      security: '企业安全',
      securityDesc: '基于硬件的密钥存储和隔离的军事级安全',
      openSource: '开源',
      openSourceDesc: '完全开源的代码库，用于透明度和社区贡献',
      getStarted: '准备开始？',
      getStartedDesc: '使用硬件钱包设备探索 OneKey SDK 功能',
      tryDemo: '立即试用演示',
      initializing: '初始化中',
      waiting: '等待',
      unknown: '未知设备',
      connectionRequired: '需要设备连接',
      pleaseConnectFirst: '请先连接硬件设备后再执行操作',
      noActiveConnection: '无活动连接',
      connectOnHomePage: '在主页上连接您的设备以开始',
      connectedVia: '通过 {{transport}} 连接',
    },
    device: {
      webusb: '网页USB',
      jsbridge: 'JS桥接',
      bluetooth: '蓝牙',
      webUSB: 'WebUSB',
      selectDevice: '选择设备',
      noDevices: '未找到设备请连接设备',
      scanning: '正在扫描设备...',
      connectDevice: '连接并解锁您的设备',
      connectionSuccess: '连接成功！',
      connectionError: '连接失败请重试',
      connectionMethod: '连接方式',
      selectConnection: '选择连接方式',
      connected: '已连接',
      disconnected: '已断开连接',
      notSelected: '未选择',
      status: '设备状态',
      connection: '设备连接',
      ready: '就绪',
      initializing: '初始化中',
      waiting: '等待',
      unknown: '未知设备',
      connectionRequired: '需要设备连接',
      pleaseConnectFirst: '请先连接硬件设备后再执行操作',
      noActiveConnection: '无活动连接',
      connectOnHomePage: '在主页上连接您的设备以开始',
      searchDevices: '搜索设备',
      connectedTo: '已连接到',
    },
    signer: {
      btc: 'BTC',
      eth: 'EVM',
      sol: 'SOL',
      path: '派生路径',
      message: '消息',
      txData: '交易数据',
      deviceInteraction: '设备交互',
      eventLogs: '事件日志',
      clearLogs: '清除日志',
      noEvents: '暂无记录事件',
      processing: '处理中',
      waitingForAction: '等待操作...',
      actionRequired: '需要操作',
      readyForOperation: '准备操作',
      followInstructions: '请按照设备上的说明进行操作',
      confirmAddress: '确认地址',
      signMessage: '签名消息',
      reviewTransaction: '审核交易',
      deviceDisplay: '设备显示',
    },
    deviceMethods: {
      title: '设备方法',
      subtitle: '访问设备信息、管理设置并执行设备特定操作',
      totalMethods: '{{count}} 个方法',
      totalCategories: '{{count}} 个分类',
      categories: {
        basic: {
          name: '基础操作',
          description: '设备连接和基本信息获取',
        },
        device: {
          name: '设备管理',
          description: '设备设置和常用操作',
        },
        firmware: {
          name: '固件更新',
          description: '固件检查、更新和重启操作',
        },
        advanced: {
          name: '高级功能',
          description: 'U2F、验证和危险操作',
        },
        basicOperations: {
          name: '基本操作',
          description: '设备连接和信息查询',
        },
        deviceManagement: {
          name: '设备管理',
          description: 'PIN码、设置和安全',
        },
        firmwareUpdate: {
          name: '固件更新',
          description: '固件、bootloader 和蓝牙更新',
        },
        releaseInformation: {
          name: '版本信息',
          description: '版本检查和发布数据',
        },
        deviceControl: {
          name: '设备控制',
          description: '重启和bootloader操作',
        },
      },
    },
    chains: {
      title: 'Chains',
      subtitle: '通过您的 OneKey 设备与不同的区块链网络进行交互',
      searchPlaceholder: '搜索区块链...',
      availableChains: '{{count}} 个可用区块链',
      methodsCount: '{{count}} 个方法',
      noResults: '没有找到 "{{searchTerm}}" 相关的区块链',
      exploreChain: '探索 {{chainId}} 方法',
    },
    // 添加方法描述翻译
    methodDescriptions: {
      btcGetAddress: '获取 Bitcoin 地址',
      btcGetPublicKey: '获取 Bitcoin 公钥',
      btcSignMessage: '使用 Bitcoin 私钥签名消息',
      btcSignPsbt: '签名部分签名的 Bitcoin 交易 (PSBT)',
      btcSignTransaction: '使用 Bitcoin 私钥签名交易',
      btcVerifyMessage: '验证 Bitcoin 消息签名',
      alephiumGetAddress: '获取 Alephium 地址',
      alephiumSignMessage: '使用 Alephium 私钥签名消息',
      alephiumSignTransaction: '使用 Alephium 私钥签名交易',
      algoGetAddress: '获取 Algorand 地址',
      algoSignTransaction: '使用 Algorand 私钥签名交易',
      allNetworkGetAddress: '批量获取多链地址',
      aptosGetAddress: '获取 Aptos 地址',
      aptosGetPublicKey: '获取 Aptos 公钥',
      aptosSignMessage: '使用 Aptos 私钥签名消息',
      aptosSignTransaction: '使用 Aptos 私钥签名交易',
      benfenGetAddress: '获取 Benfen 地址',
      benfenGetPublicKey: '获取 Benfen 公钥',
      benfenSignMessage: '使用 Benfen 私钥签名消息',
      benfenSignTransaction: '使用 Benfen 私钥签名交易',
      cardanoGetAddress: '获取 Cardano 地址',
      cardanoGetPublicKey: '获取 Cardano 公钥',
      cardanoSignMessage: '使用 Cardano 私钥签名消息',
      cardanoSignTransaction: '使用 Cardano 私钥签名交易',
      checkAllFirmwareRelease: '检查所有固件版本信息',
      checkBLEFirmwareRelease: '检查蓝牙固件版本信息',
      checkBootloaderRelease: '检查引导程序版本信息',
      checkBridgeRelease: '检查桥接程序版本信息',
      checkFirmwareRelease: '检查固件版本信息',
      confluxGetAddress: '获取 Conflux 地址',
      confluxSignMessage: '使用 Conflux 私钥签名消息',
      confluxSignMessageCIP23: '使用 CIP23 标准签名消息',
      confluxSignTransaction: '使用 Conflux 私钥签名交易',
      cosmosGetAddress: '获取 Cosmos 地址',
      cosmosGetPublicKey: '获取 Cosmos 公钥',
      cosmosSignTransaction: '使用 Cosmos 私钥签名交易',
      deviceCancel: '取消设备操作',
      deviceChangePin: '更改设备 PIN 码',
      deviceLock: '锁定设备',
      deviceRebootToBoardloader: '重启到引导模式（仅限 Pro 和 Touch 设备）',
      deviceRebootToBootloader: '重启设备到引导模式',
      deviceSettings: '配置设备设置',
      deviceSupportFeatures: '检查设备支持的功能',
      deviceUpdateBootloader: '更新设备引导程序',
      deviceVerify: '验证设备真实性',
      deviceWipe: '清除设备数据（危险：这将删除所有数据）',
      dnxGetAddress: '获取 Dynex 地址',
      dnxSignTransaction: '使用 Dynex 私钥签名交易',
      evmGetAddress: '获取 EVM 地址',
      evmGetPublicKey: '获取 EVM 公钥',
      evmSignMessage: '使用 EVM 账户签名消息',
      evmSignMessageEIP712:
        '使用 EVM 账户签名消息，经典版和迷你版固件版本大于 2.1.8 且小于 2.2.0 时可用',
      evmSignTransaction: '使用 EVM 账户签名交易',
      evmSignTypedData: '使用 EVM 账户签名结构化数据',
      evmVerifyMessage: '验证 EVM 消息签名',
      filecoinGetAddress: '获取 Filecoin 地址',
      filecoinSignTransaction: '使用 Filecoin 私钥签名交易',
      firmwareUpdateV2: '兼容所有设备',
      firmwareUpdateV3: '仅适用于 Pro 设备且引导程序版本 > 4.12.0',
      getFeatures: '获取设备功能信息',
      getLogs: '获取设备日志',
      getNextU2FCounter: '获取下一个 U2F 计数器值',
      getOnekeyFeatures: '获取 OneKey 特有功能信息',
      getPassphraseState: '获取设备密码状态',
      kaspaGetAddress: '获取 Kaspa 地址',
      kaspaSignTransaction: '使用 Kaspa 私钥签名交易',
      lnurlAuth: 'LNURL 身份验证',
      nearGetAddress: '获取 NEAR 地址',
      nearSignTransaction: '使用 NEAR 私钥签名交易',
      nemGetAddress: '获取 NEM 地址',
      nemSignTransaction: '使用 NEM 私钥签名交易',
      neoGetAddress: '获取 NEO 地址',
      neoSignTransaction: '使用 NEO 私钥签名交易',
      nervosGetAddress: '获取 Nervos 地址',
      nervosSignTransaction: '使用 Nervos 私钥签名交易',
      nexaGetAddress: '获取 Nexa 地址',
      nexaSignTransaction: '使用 Nexa 私钥签名交易',
      nostrDecryptMessage: '解密 Nostr 消息',
      nostrEncryptMessage: '加密 Nostr 消息',
      nostrGetPublicKey: '获取 Nostr 公钥',
      nostrSignEvent: '签名 Nostr 事件',
      nostrSignSchnorr: '使用 Schnorr 算法签名',
      polkadotGetAddress: '获取 Polkadot 地址',
      polkadotSignTransaction: '使用 Polkadot 私钥签名交易',
      scdoGetAddress: '获取 SCDO 地址',
      scdoSignMessage: '使用 SCDO 私钥签名消息',
      scdoSignTransaction: '使用 SCDO 私钥签名交易',
      searchDevices: '搜索设备',
      setU2FCounter: '设置 U2F 计数器值',
      solGetAddress: '获取 Solana 地址',
      solSignMessage: '使用 Solana 私钥签名消息',
      solSignOffchainMessage: '签名链下消息',
      solSignTransaction: '使用 Solana 私钥签名交易',
      starcoinGetAddress: '获取 Starcoin 地址',
      starcoinGetPublicKey: '获取 Starcoin 公钥',
      starcoinSignMessage: '使用 Starcoin 私钥签名消息',
      starcoinSignTransaction: '使用 Starcoin 私钥签名交易',
      starcoinVerifyMessage: '验证 Starcoin 消息签名',
      stellarGetAddress: '获取 Stellar 地址',
      stellarSignTransaction: '使用 Stellar 私钥签名交易',
      suiGetAddress: '获取 Sui 地址',
      suiGetPublicKey: '获取 Sui 公钥',
      suiSignMessage: '使用 Sui 私钥签名消息',
      suiSignTransaction: '使用 Sui 私钥签名交易',
      tonGetAddress: '获取 TON 地址',
      tonSignMessage: '使用 TON 私钥签名消息',
      tonSignProof: '签名 TON 证明',
      tronGetAddress: '获取 Tron 地址',
      tronSignMessage: '使用 Tron 私钥签名消息',
      tronSignTransaction: '使用 Tron 私钥签名交易',
      xrpGetAddress: '获取 XRP 地址',
      xrpSignTransaction: '使用 XRP 私钥签名交易',
    },
    deviceOperations: {
      deviceStatus: {
        title: '设备状态',
        description: '检查设备的当前状态和功能',
      },
      firmware: {
        title: '固件更新',
        description: '检查固件更新并管理设备软件',
      },
      passphraseStatus: {
        title: 'Passphrase状态',
        description: '检查和管理设备上的passphrase保护',
      },
      deviceVerification: {
        title: '设备验证',
        description: '验证您的OneKey设备的真实性',
      },
      configTitle: '操作配置',
      requestParams: '请求参数',
      autoFilled: '自动填充',
      showAdvanced: '显示高级选项',
      hideAdvanced: '隐藏高级选项',
      timeout: '请求超时',
      developerTools: '开发者工具',
      execute: '执行',
      cancel: '取消',
      cancelOperation: '取消操作',
      restart: '重新开始',
      backToList: '返回列表',
      executionStatus: '执行状态',
      deviceInteraction: '设备交互',
      waitForDevice: '等待设备响应...',
      deviceInstructions: '请按照设备上的说明完成操作',
      errorDetails: '错误详情',
      errorCode: '错误代码',
      possibleSolutions: '可能的解决方案',
      solutions: {
        confirmOnDevice: '确保在设备上确认操作',
        ensureUnlocked: '确保您的设备已解锁',
        checkConnection: '检查设备连接',
      },
      responseData: '响应数据',
      operationLogs: '操作日志',
      clearLogs: '清除日志',
      noLogs: '没有可用的日志',
      executionId: '执行ID',
      status: {
        ready: '准备执行',
        preparing: '准备请求',
        completed: '请求完成',
        deviceInteraction: '与设备交互中',
        deviceInteractionCompleted: '设备交互完成',
        deviceInteractionFailed: '设备交互失败',
        success: '操作成功',
        failed: '操作失败',
        completion: '完成',
      },
      errors: {
        timeout: '操作超时',
        canceled: '用户取消操作',
        unknown: '发生未知错误',
      },
      logMessages: {
        requestSent: '请求已发送: {{operation}}',
        timeout: '操作超时',
        waitingForDevice: '等待设备响应...',
        operationCompleted: '操作成功完成',
        operationFailed: '操作失败: {{error}}',
        exception: '发生异常: {{error}}',
        operationCanceled: '用户取消操作',
      },
    },
    logs: {
      title: '系统日志',
      clear: '清除日志',
      time: '时间',
      type: '类型',
      message: '消息',
      noLogsToShare: '没有可分享的日志',
      records: '记录',
      searchPlaceholder: '按内容、类型或消息搜索日志...',
      noLogs: '没有操作日志',
      noLogsDesc: '连接设备并执行操作以在此处查看日志',
      executeOperation: '执行操作',
      deviceLogs: '设备操作日志',
      deviceLogsDesc: '显示最近的设备操作记录，包括连接、签名和错误消息',
      configuration: '配置',
      cleanupExpired: '清理过期',
      exportJson: '导出JSON',
      exportText: '导出文本',
      storageConfig: {
        title: '日志存储配置',
        description: '配置日志的存储策略，包括大小限制、过期时间和压缩设置',
        maxEntries: '最大条数',
        expirationDays: '过期天数',
        maxSizeMb: '最大大小 (MB)',
        enableCompression: '启用压缩',
        reset: '重置',
        save: '保存',
      },
      stats: {
        totalEntries: '总条数',
        storageSize: '存储大小',
        oldestRecord: '最早记录',
        newestRecord: '最新记录',
        none: '无',
      },
      exportMessages: {
        success: '导出成功',
        successDesc: '已导出 {{count}} 条日志记录',
        failed: '导出失败',
        noLogs: '没有可导出的日志',
        error: '导出过程中发生错误',
      },
      cleanup: {
        completed: '清理完成',
        completedDesc: '已清理 {{count}} 条过期日志',
      },
      config: {
        saved: '配置已保存',
        savedDesc: '日志存储配置已更新',
      },
    },
    logDisplay: {
      title: '设备日志',
      filterAll: '所有日志',
      filterInfo: '信息',
      filterError: '错误',
      filterRequest: '请求',
      filterResponse: '响应',
      clear: '清除日志',
      noLogs: '无可用日志',
    },
    dashboard: {
      title: 'OneKey 开发者控制台',
      deviceInfo: '设备信息',
      connectId: '连接 ID',
      deviceType: '设备型号',
      deviceConnected: '设备连接成功',
      deviceInstructions: '您现在可以使用以下设备功能与您的 OneKey 设备进行交互',
    },
    pin: {
      title: '输入PIN码',
      instruction: '请输入您的设备PIN码',
      enterPin: '输入PIN码',
      enterPinWeb: '在网页端输入PIN码',
      webInputInstruction: '您的设备支持在网页端安全输入PIN码，这样更方便快捷',
      webSubmit: '网页确认',
      confirmPin: '确认PIN码',
      pinRequired: '此操作需要PIN码',
      incorrectPin: 'PIN码错误，请重试',
      cancel: '取消',
      submit: '提交',
      deviceInput: '使用设备输入',
      webInput: '使用网页输入',
      checkDeviceLayout: '请查看设备屏幕上的键盘布局',
    },
    passphrase: {
      title: '输入Passphrase',
      instruction: '请输入设备的passphrase（可选）',
      enterPassphrase: '输入Passphrase',
      confirmPassphrase: '确认Passphrase',
      passphraseOptional: 'Passphrase是可选的额外安全保护',
      enablePassphrase: '启用Passphrase保护',
      disablePassphrase: '禁用Passphrase保护',
      cancel: '取消',
      submit: '提交',
      deviceInput: '使用设备输入',
      webInput: '使用网页输入',
      showPassphrase: '显示Passphrase',
      hidePassphrase: '隐藏Passphrase',
      passphraseInfo: 'Passphrase为您的钱包增加额外的安全层',
      placeholder: '请输入Passphrase',
      confirmPlaceholder: '请再次输入Passphrase',
      saveToSession: '保持可访问隐藏的钱包在您关闭应用后仍然保留',
      inputOnDevice: '在设备上输入',
      useDevice: '使用设备输入',
      deviceInputDescription: '将在设备上安全输入passphrase',
      webInputDescription: '在网页上输入passphrase以继续',
      warningMessage: 'Passphrase 遗失将无法恢复',
      maxLength: '最多 50 个字符',
    },
    transport: {
      webusb: {
        description: '推荐',
        deviceConnected: 'WebUSB设备连接成功',
        noDeviceSelected: '未选择设备',
        notSupported: '此浏览器不支持WebUSB',
      },
      jsbridge: {
        description: '稳定兼容',
      },
      emulator: {
        description: '开发测试',
      },
      webble: {
        description: '蓝牙连接',
      },
      comingSoon: '即将推出',
      sdkNotReady: 'SDK未就绪',
      pleaseWaitForInit: '请等待SDK初始化完成后再切换传输方式',
      switchFailed: '切换传输方式失败',
      connectionFailed: '连接失败',
      connectionSuccessful: '连接成功',
      noDevicesFound: '未找到设备',
      ensureDeviceConnected: '请确保设备已连接并解锁',
      searchFailed: '搜索失败',
      searchDeviceFailed: '搜索设备失败',
      connectionTip: '连接提示',
      unknownConnectionError: '连接过程中发生未知错误',
      needsBridge: '需要',
      downloadBridge: '下载Bridge',
      needsEmulator: '需要',
      startEmulator: '启动模拟器',
      sdkInitializing: '初始化...',
      sdkInitError: 'SDK初始化失败',
    },
    sdk: {
      browserRequired: '需要浏览器环境',
      initError: 'SDK初始化失败',
      initFailed: '初始化失败: {{error}}',
    },
    search: {
      sections: {
        interface: '界面控制',
        navigation: '导航',
        documentation: '文档',
        external: '外部链接',
        blockchains: '区块链',
        deviceMethods: '设备方法',
        chainMethods: '链方法',
      },
      actions: {
        toggleSidebar: '切换侧边栏',
        lightTheme: 'light theme',
        darkTheme: 'dark theme',
        home: '首页',
        emulator: 'Hardware Emulator',
        logs: 'Logs',
        deviceMethods: 'Device',
        chains: 'Signer',
        githubRepo: 'GitHub Repository',
        githubIssues: 'GitHub Issues',
        githubReleases: 'GitHub Releases',
        onekeyDocs: 'OneKey Documentation',
        onekeyWebsite: 'OneKey Website',
        hardwareConnect: 'Hardware Connect Guide',
      },
      descriptions: {
        emulator: '使用 Docker 启动硬件模拟器',
        logs: '查看操作日志和调试信息',
        deviceMethods: '硬件设备管理和固件更新相关的 API 方法',
        chains: '支持的区块链和相关方法',
        githubRepo: 'OneKey Hardware JS SDK 源代码仓库',
        githubIssues: '报告问题或查看已知问题',
        githubReleases: '查看版本发布历史和更新日志',
        onekeyDocs: 'OneKey 官方开发文档',
        onekeyWebsite: 'OneKey 官方网站',
        hardwareConnect: '硬件设备连接指南',
      },
      keywords: {
        sidebar: 'sidebar toggle 侧边栏 切换 显示 隐藏',
        theme: 'theme light dark 主题 浅色 深色 明亮 暗色',
        home: 'home 首页 主页',
        emulator: 'emulator hardware 模拟器 硬件 docker',
        logs: 'logs debug 日志 调试',
        device: 'device methods firmware update api 设备 方法 固件 更新',
        chains: 'blockchain signer 区块链',
        github: 'github repository source code 源代码 仓库',
        issues: 'github issues bug report 问题 报告 反馈',
        releases: 'github releases changelog version 版本 发布 更新',
        docs: 'documentation docs onekey 文档 开发',
        website: 'website onekey official 官网 网站',
        connect: 'hardware connect guide tutorial 硬件 连接 指南 教程',
      },
      sortModes: {
        priority: '按优先级',
        alphabetical: '按字母顺序',
        section: '按分组',
      },
      placeholder: '搜索',
      inputPlaceholder: '搜索方法和区块链...',
      navigate: '导航',
      select: '选择',
      close: '关闭',
    },
    emulator: {
      title: '硬件模拟器',
      subtitle: '使用 Docker 快速启动 OneKey 硬件模拟器进行开发测试',
      hero: {
        title: '无需物理设备即可测试硬件钱包',
        subtitle: '5分钟内开始编码',
        promise: '快速设置 • 无需硬件 • 完整功能',
      },
      flow: {
        browser: '浏览器',
        docker: 'Docker',
        virtual: '虚拟设备',
        app: '您的应用',
      },
      progressTitle: '设置进度',
      steps: {
        title: '简单的4步流程',
        subtitle: '几分钟内启动模拟器',
        setup: {
          title: '下载脚本',
          description: '克隆模拟器代码仓库',
          longDescription:
            '首先，我们需要下载模拟器设置脚本此仓库包含运行 OneKey 硬件模拟器所需的所有 Docker 配置和启动脚本',
        },
        device: {
          title: '选择设备',
          description: '选择要模拟的设备类型',
        },
        launch: {
          title: '启动模拟器',
          description: '启动选择的模拟器',
        },
        connect: {
          title: '连接应用',
          description: '准备开始开发',
        },
      },
      step1: {
        title: '下载脚本',
        description: '一行命令克隆模拟器仓库',
      },
      step2: {
        title: '选择设备',
        description: '选择 OneKey Pro 或 Classic 1s 模拟器',
      },
      step3: {
        title: '开始编码',
        description: '连接到您的应用并开始开发',
      },
      devices: {
        pro: {
          description: '功能齐全的硬件钱包，配备触摸屏',
        },
        classic: {
          description: '基本款硬件钱包，采用按键界面',
        },
      },
      device: {
        pro: {
          description: '功能齐全的硬件钱包，配备触摸屏',
        },
        classic: {
          description: '基本款硬件钱包，采用按键界面',
        },
      },
      quickStart: '快速开始',
      cloneRepo: '克隆 Git 仓库',
      cloneRepository: '克隆代码仓库',
      startEmulator: '启动模拟器',
      connectToApp: '连接到应用',
      downloadScript: '下载模拟器脚本',
      scriptDescription: '包含所有平台的一键启动脚本',
      startCommands: '启动',
      selectMode: '选择您偏好的连接模式',
      launchingDevice: '正在启动',
      selectLaunchMode: '请在下方选择您偏好的启动模式',
      recommended: '推荐',
      copied: '已复制！',
      copiedDesc: '命令已复制到剪贴板',
      copyFailed: '复制命令失败',
      copyFailedDesc: '无法复制到剪贴板',
      copyCommand: '复制命令',
      congratulations: '恭喜！',
      emulatorReady: '您的模拟器已准备就绪，可以开始开发',
      nextSteps: '后续步骤',
      vncMode: 'VNC 模式',
      vncDescription: '所有平台通用，启动后访问 http://localhost:6088/vnc.html',
      x11Mode: 'X11 模式',
      x11Description: '仅限 Linux，原生窗口显示',
      connectionInstructions: '在首页切换连接方式',
      connectionSteps: {
        step1: '返回首页，在连接设置中选择 "模拟器" 传输方式',
        step2: '点击连接按钮，系统会自动检测运行中的模拟器',
        step3: '开始使用完整的硬件钱包功能进行开发测试',
      },
      developmentResources: '开发资源',
      resourcesDescription: '开发相关的有用链接和文档',
      gitRepo: 'Git 仓库',
      gitRepoDesc: '源代码和设置脚本',
      documentation: '详细文档',
      docDesc: '完整的开发指南',
      comingSoon: '即将发布',
      docInProgress: '文档正在完善中',
      docInProgressDesc: '详细文档即将发布，敬请期待',
      vncModeNote: '跨平台通用，通过浏览器访问模拟器界面，无需额外配置',
      x11ModeNote: 'Linux 专用，原生窗口显示，性能更佳',
      stepProgress: '第 {{current}} 步，共 {{total}} 步',
      launchVncMode: '启动 VNC 模式',
      launchX11Mode: '启动 X11 模式',
      copyAndRunHint: '复制并运行上方的命令来启动模拟器',
      connectStep1Title: '访问模拟器界面',
      connectStep1Desc: 'VNC模式，在浏览器中查看',
      connectStep1Action: '打开 localhost:6088',
      connectStep2Title: '切换连接方式',
      connectStep2Desc: '在首页选择模拟器传输方式',
      connectStep2Action: '返回首页',
      connectStep3Title: '开始开发测试',
      connectStep3Desc: '使用完整的硬件钱包功能进行开发和测试',
    },
    components: {
      deviceConnectionAlert: {
        defaultMessage: '请先连接硬件设备后再执行操作',
      },
      collapsibleJsonViewer: {
        copied: '已复制',
        copyFailed: '复制失败',
        copyToClipboard: '内容已复制到剪贴板',
        cannotCopyToClipboard: '无法复制到剪贴板',
        objectCopied: '对象已复制到剪贴板',
        arrayCopied: '数组已复制到剪贴板',
        items: '项',
      },
      executionPanel: {
        requestParameters: '请求参数',
        executionLogs: '执行日志',
        copySuccess: '复制成功',
        copySuccessDesc: '请求参数已复制到剪贴板',
        copyFailed: '复制失败',
        copyFailedDesc: '无法复制到剪贴板',
      },
      firmwareFileUpload: {
        clickToSelect: '点击选择文件或拖拽文件到此处',
        supportedFormats: '支持格式',
        maxSize: '最大',
        fileSizeTooLarge: '文件大小超过限制',
        unsupportedFormat: '不支持的文件格式支持的格式',
        firmwareFile: '固件文件',
        firmwareDesc: '主固件程序文件，用于更新设备核心功能',
        bootloaderFile: 'Bootloader文件',
        bootloaderDesc: '引导程序文件，用于更新设备启动程序',
        bleFile: 'BLE固件文件',
        bleDesc: '蓝牙低功耗固件文件，用于更新蓝牙功能',
        resourceFile: '资源文件',
        resourceDesc: '设备界面资源包，包含图标、字体等界面元素',
        selectFile: '选择{{title}}...',
        helpInfo: {
          line1: '• 请确保固件文件来源可靠，避免使用未经验证的固件',
          line2: '• 更新过程中请勿断开设备连接或关闭浏览器',
          line3: '• 建议在更新前备份重要数据',
        },
      },
      jsonEditor: {
        editJsonContent: '编辑 JSON 内容',
        jsonContent: 'JSON内容',
        enterJsonData: '请输入JSON格式的数据...',
        jsonFormatError: 'JSON格式不正确，请检查语法',
        noData: '暂无数据',
      },
      listBoundary: {
        preparingData: '准备数据...',
        dataNotFound: '数据未找到',
        noDataAvailable: '没有可用数据',
      },
      methodExecuteBoundary: {
        methodNotFound: '方法未找到',
        methodNotFoundDesc: '无法找到请求的方法',
      },
      methodExecutor: {
        deviceNotConnected: '设备未连接',
        connectDeviceFirst: '请先连接硬件设备',
        expectedUserExperience: '期望的用户体验：',
        deviceConnected: '设备已连接，准备执行',
        connectDevice: '请连接设备',
        executing: '正在执行...',
        executionSuccess: '执行成功',
        executionFailed: '执行失败',
        waitingExecution: '等待执行',
        executing2: '执行中',
        cancelling: '取消中',
      },
      parameterInput: {
        quickPresets: '快捷预设',
        selectPreset: '选择预设配置',
        commonParameters: '通用参数',
        methodParameters: '方法参数',
        useEmptyPassphrase: 'useEmptyPassphrase',
        useEmptyPassphraseDesc: '使用空passphrase',
        usePassphraseState: '是否使用passPhraseState',
        usePassphraseStateDesc: '设备中已保存的passphrase状态字符串',
        currentlyNoPassphraseState: '目前无passphraseState',
        parametersInBundle: '参数在 bundle 数组中配置',
        noAdditionalParams: '无需配置额外参数',
        selectPresetFirst: '请先选择预设配置',
        batchMode: '批量模式：',
        batchModeDesc: '方法参数在 bundle 数组中，外层仅保留通用参数',
        selectFirmwareFile: '选择{{title}}...',
        firmwareFileHelp: {
          line1: '• 请确保固件文件来源可靠，避免使用未经验证的固件',
          line2: '• 更新过程中请勿断开设备连接或关闭浏览器',
          line3: '• 建议在更新前备份重要数据',
        },
        passphraseState: 'PassphraseState',
        passphraseStateDesc: '使用passphraseState隐藏钱包',
        deriveCardano: 'deriveCardano',
        deriveCardanoDesc: '启用Cardano地址派生',
      },
      unifiedLogger: {
        executionLogs: '执行日志',
        records: '条记录',
        searchLogs: '搜索日志...',
        all: '全部',
        request: '请求',
        response: '响应',
        hardware: '硬件',
        info: '信息',
        noLogs: '暂无日志记录',
        noMatchingLogs: '没有匹配的日志',
        logsCopied: '已复制',
        logsCopiedDesc: '日志内容已复制到剪贴板',
        copyLogsFailed: '复制失败',
        copyLogsFailedDesc: '无法复制到剪贴板',
        lines: '行',
        expandLines: '展开 ({{count}} 行)',
        collapseLines: '收起 ({{count}} 行)',
        scrollToTop: '回到顶部',
      },
      deviceInteractionArea: {
        transferringData: '传输数据',
        transferringDataDesc: '正在将固件数据传输到设备...',
        installingFirmware: '安装固件',
        installingFirmwareDesc: '正在安装固件，请勿断开设备...',
      },
      webusb: {
        authorize: {
          title: '授权 WebUSB',
          description:
            '您的设备已切换到引导模式（bootloader）以应用更新。Chrome 将其视为新的 USB 设备。请授权以继续固件更新。',
          tip: '请确保设备已连接。如果未弹出选择器，尝试更换 USB 接口或重新连接数据线。',
          selectButton: '选择设备',
          selecting: '正在选择...',
          troubleshooting: '如果关闭此弹窗或取消选择，更新将暂停。准备好后可再次打开此弹窗继续。',
        },
      },
    },
  },
};
